<base-index-page [config]="baseIndexPageConfig" 
    [service]="specialisationsService"
    [idKey]="'employeeSpecialisationId'"></base-index-page>
